import { Link } from "react-router-dom";
import { useGetSettingQuery } from "../../../../Redux/Apis/siteApi";

function About() {
    const {data : {home: {about : {data}}}} = useGetSettingQuery()

    return ( 
        <div className="abt-section mb-150">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-12">
                        <div className="abt-bg" style={{backgroundImage: `url(${data.img_image})`}}>
                            {data.lnk_video && <a href={data.lnk_video} target="_blank" rel="noreferrer" className="video-play-btn popup-youtube">
                                <i className="fas fa-play"></i>
                            </a>}
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="abt-text">
                            {data.txt_establish && <p className="top-sub">{data.txt_establish}</p>}
                            {data.txt_name && <h2><span className="orange-text">{data.txt_name.split(" ")[0]} </span> {data.txt_name.split(" ").slice(1).join(" ")}</h2>}
                            {data.txe_description && <p>{data.txe_description}</p>}
                            <Link to="/about" className="boxed-btn mt-4">آشنایی بیشتر</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     );
}

export default About;       